import LeaEditTableColumn from "../edit-table/LeaEditTableColumn.vue";

export default LeaEditTableColumn;
